export const roleEndpoints = {
  allPermissions: '/admin/roles/permissions', // GET
  list: '/admin/roles', // GET
  create: '/admin/roles', // POST
  detail: (id: string) => `/admin/roles/${id}`, // GET
  update: (id: string) => `/admin/roles/${id}`, // PUT
  delete: (id: string) => `/admin/roles/${id}`, // DELETE
}

export const roleBackendErrors = {
  ROLE_NAME_ALREADY_EXISTS: 'Bu rol adı zaten kullanılıyor.',
  ROLE_IS_ASSIGNED: 'Bu rol bir kullanıcıya atanmış olduğu için silinemez.',
  ROLE_NOT_FOUND: 'Rol bulunamadı.',
  ROLE_CREATE: 'Rol oluşturulurken hata oluştu.',
  ROLE_UPDATE: 'Rol güncellenirken hata oluştu.',
  ROLE_EDIT: 'Rol güncellenirken hata oluştu.',
  ROLE_DELETE: 'Rol silinirken hata oluştu.',
  PERMISSION_NOT_FOUND: 'Seçilen yetkilerden biri bulunamadı.',
  ADMIN_USER_NOT_FOUND: 'Yönetici kullanıcı bulunamadı.',
  ADMIN_USER_UPDATE: 'Yönetici rolleri güncellenirken hata oluştu.',
  GENERAL_ERROR: 'Beklenmeyen bir hata oluştu.',
} as const

export const roleSuccessMessages = {
  roleCreate: 'Rol başarıyla oluşturuldu.',
  roleEdit: 'Rol başarıyla güncellendi.',
  roleDelete: 'Rol başarıyla silindi.',
}

export const permissions = [
  'categories.list',
  'categories.create',
  'categories.edit',
  'categories.delete',
  'questions.list',
  'questions.detail',
  'questions.create',
  'questions.bulk-import',
  'questions.edit',
  'questions.delete',
  'question-pools.list',
  'question-pools.detail',
  'question-pools.create',
  'question-pools.edit',
  'question-pools.delete',
  'question-pools.manage-questions',
  'avatars.list',
  'avatars.create',
  'avatars.edit',
  'avatars.delete',
  'emotes.list',
  'emotes.detail',
  'emotes.create',
  'emotes.edit',
  'emotes.delete',
  'players.list',
  'players.detail',
  'players.edit',
  'admins.list',
  'admins.detail',
  'admins.create',
  'admins.edit',
  'admins.delete',
  'roles.list',
  'roles.detail',
  'roles.create',
  'roles.edit',
  'roles.delete',
  'user-roles.list',
  'user-roles.detail',
  'user-roles.create',
  'user-roles.edit',
  'users.roles.assign',
  'teams.list',
  'teams.detail',
  'teams.edit',
  'teams.delete',
  'team-tags.list',
  'team-tags.create',
  'team-tags.edit',
  'team-tags.delete',
  'lobbies.inspect',
  'notifications.send',
  'tournaments.list',
  'tournaments.detail',
  'tournaments.create',
  'tournaments.edit',
  'tournaments.delete',
  'tournaments.moderate',
  'leagues.list',
  'leagues.detail',
  'leagues.create',
  'leagues.edit',
  'leagues.delete',
  'leagues.reassign',
  'leagues.moderate',
  'seasons.list',
  'seasons.detail',
  'seasons.create',
  'seasons.edit',
  'seasons.delete',
] as const

export const permissionsLabels: Record<string, string> = {
  'categories.list': 'Kategori Listesi',
  'categories.create': 'Kategori Oluştur',
  'categories.edit': 'Kategori Düzenle',
  'categories.delete': 'Kategori Sil',
  'questions.list': 'Soru Listele',
  'questions.detail': 'Soru Detay',
  'questions.create': 'Soru Oluştur',
  'questions.bulk-import': 'Soru Toplu İçe Aktar',
  'questions.edit': 'Soru Düzenle',
  'questions.delete': 'Soru Sil',
  'question-pools.list': 'Soru Havuzu Listele',
  'question-pools.detail': 'Soru Havuzu Detay',
  'question-pools.create': 'Soru Havuzu Oluştur',
  'question-pools.edit': 'Soru Havuzu Düzenle',
  'question-pools.delete': 'Soru Havuzu Sil',
  'question-pools.manage-questions': 'Soru Havuzu Sorularını Yönet',
  'avatars.list': 'Avatar Listele',
  'avatars.create': 'Avatar Oluştur',
  'avatars.edit': 'Avatar Düzenle',
  'avatars.delete': 'Avatar Sil',
  'emotes.list': 'Emoji Listele',
  'emotes.detail': 'Emoji Detay',
  'emotes.create': 'Emoji Oluştur',
  'emotes.edit': 'Emoji Düzenle',
  'emotes.delete': 'Emoji Sil',
  'players.list': 'Oyuncuları Listele',
  'players.detail': 'Oyuncu Detay',
  'players.edit': 'Oyuncu Düzenle',
  'admins.list': 'Admin Listele',
  'admins.detail': 'Admin Detay',
  'admins.create': 'Admin Oluştur',
  'admins.edit': 'Admin Düzenle',
  'admins.delete': 'Admin Sil',
  'roles.list': 'Rol Listele',
  'roles.detail': 'Rol Detay',
  'roles.create': 'Rol Oluştur',
  'roles.edit': 'Rol Düzenle',
  'roles.delete': 'Rol Sil',
  'user-roles.list': 'Oyuncu Rolü Listele',
  'user-roles.detail': 'Oyuncu Rolü Detay',
  'user-roles.create': 'Oyuncu Rolü Oluştur',
  'user-roles.edit': 'Oyuncu Rolü Düzenle',
  'users.roles.assign': 'Oyuncu Rolü Ata',
  'teams.list': 'Takım Listele',
  'teams.detail': 'Takım Detay',
  'teams.edit': 'Takım Düzenle',
  'teams.delete': 'Takım Sil',
  'team-tags.list': 'Takım Etiketi Listele',
  'team-tags.create': 'Takım Etiketi Oluştur',
  'team-tags.edit': 'Takım Etiketi Düzenle',
  'team-tags.delete': 'Takım Etiketi Sil',
  'lobbies.inspect': 'Aktif Lobiler İncele',
  'notifications.send': 'Bildirim Gönder',
  'tournaments.list': 'Turnuva Listele',
  'tournaments.detail': 'Turnuva Detay',
  'tournaments.create': 'Turnuva Oluştur',
  'tournaments.edit': 'Turnuva Düzenle',
  'tournaments.delete': 'Turnuva Sil',
  'tournaments.moderate': 'Turnuva Moderatörlüğü',
  'seasons.list': 'Sezon Listele',
  'seasons.detail': 'Sezon Detay',
  'seasons.create': 'Sezon Oluştur',
  'seasons.edit': 'Sezon Düzenle',
  'seasons.delete': 'Sezon Sil',
  'league.access': 'Bilgi Ligine Erişim',
  'team.create': 'Takım Oluştur',
  'team.update': 'Takım Düzenle',
  'team.delete': 'Takım Sil',
  'team.join': 'Takıma Katıl',
  'team.leave': 'Takımdan Ayrıl',
  'team.invite': 'Takıma Davet Et',
  'team.kick': 'Takımdan Üye Çıkar',
  'team.change-leader': 'Takım Liderliğini Devret',
}

export const resourceLabels: Record<string, string> = {
  categories: 'Kategori',
  questions: 'Soru',
  'question-pools': 'Soru Havuzu',
  avatars: 'Avatar',
  emotes: 'Emojiler',
  players: 'Oyuncu',
  users: 'Kullanıcı',
  admins: 'Yönetici',
  roles: 'Rol',
  'user-roles': 'Oyuncu Rolü',
  teams: 'Takım',
  team: 'Takım',
  'team-tags': 'Takım Etiketi',
  seasons: 'Sezon',
  league: 'Bilgi Ligi',
  lobbies: 'Lobi',
  notifications: 'Bildirimler',
  tournaments: 'Turnuva',
}
